import { Component, inject } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Loggable } from 'app/utils/logging/loggable';

export interface ModalRecordingNameData {
  defaultName: string;
}

export interface ModalRecordingNameResult {
  result: boolean;
  name: string;
}

const noWhitespaceValidator = (control: AbstractControl): null | { whitespace: boolean } => {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
};

@Component({
  selector: 'modal-recording-name',
  templateUrl: './modal-recording-name.component.html',
  styleUrls: ['./modal-recording-name.component.scss'],
  standalone: false,
})
export class ModalRecordingNameComponent extends Loggable {
  private data = inject<ModalRecordingNameData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ModalRecordingNameComponent>>(MatDialogRef);

  private formBuilder = new UntypedFormBuilder();

  public formGroup: UntypedFormGroup;

  public constructor() {
    super();
    this.setDisplayName('ModalInputSocialComponent');
    this.formGroup = this.formBuilder.group({
      name: new UntypedFormControl(this.data.defaultName, [Validators.required, noWhitespaceValidator]),
    });
  }

  private get name(): string {
    const controls = this.formGroup?.controls;
    return controls?.name.value ?? '';
  }

  public cancelButtonClicked(): void {
    this.logUserAction(this.displayName, 'cancel', { name: this.name });
    this.dialogRef.close(null);
  }

  public confirmButtonClicked(): void {
    this.logUserAction(this.displayName, 'confirm', { name: this.name });
    this.dialogRef.close(this.name);
  }

  public secondaryButtonClicked(): void {
    this.dialogRef.close('secondary');
  }

  public close(): void {
    this.logUserAction(this.displayName, 'close');
    this.dialogRef.close(null);
  }
}
